import { API_SERVICE } from "./root";
import { NxExtenManageServiceClient } from "@/pbjs/external/dialer/nxExtenManage_grpc_web_pb";

let nxExtenManageClient: any = new NxExtenManageServiceClient(
  API_SERVICE,
  null,
  null
);

export { nxExtenManageClient };
